export const MINI_DRAWER_DEFAULTS = {
  EXPANDED_WIDTH: 236,
  COLLAPSED_WIDTH: 68,
  ICON_SIZE: 22,
  TRANSITION_DURATION_MS: 300,
  TOGGLE_ICON_SIZE: 20,
} as const;
